export let isMobileWidth = document.body.clientWidth <= 580;

export const payment_method_type_card = "card";

export const payment_method_type_bank = "us_bank_account";
